// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('historyPhone', ['$http', 'obexConstant', 'authService',
    ($http, obexConstant, authService) => {
      return {
        getPhoneLogsForAllMember(startDate, endDate) {
          const url = `${obexConstant.urlPhoneHistory}/admin/${startDate}/${endDate}`;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));
        },
        getPhoneLogsForMember(memberId, startDate, endDate) {
          const url = `${obexConstant.urlPhoneHistory}/admin/member/${memberId}/${startDate}/${endDate}`;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));
        },
        getPhoneLogDetailsForFlight(flightId) {
          const url = `${obexConstant.urlPhoneHistory}/admin/flight/${flightId}`;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));
        },
        getPhoneLogDetailsForCar(carId) {
          const url = `${obexConstant.urlPhoneHistory}/admin/car/${carId}`;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));
        },
        getPhoneLogDetailsForHotel(hotelId) {
          const url = `${obexConstant.urlPhoneHistory}/admin/hotel/${hotelId}`;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/phoneHistory.service.js